import { JSX, useState } from "react";
import {
    Box,
    ImageList,
    ImageListItem,
    useMediaQuery,
    useTheme,
    Dialog,
    DialogContent,
    IconButton,
    ImageListItemBar,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import FadeInWhenVisible from "../animations/FadeInWhenVisible";
import SectionTitle from "../ui/SectionTitle";

import pet1 from "../../images/pets-images/pet1.jpg";
import pet2 from "../../images/pets-images/pet2.jpg";
import pet3 from "../../images/pets-images/pet3.jpg";
import pet4 from "../../images/pets-images/pet4.jpg";
import pet5 from "../../images/pets-images/pet5.jpg";
import pet6 from "../../images/pets-images/pet6.jpg";
import pet7 from "../../images/pets-images/pet7.jpg";
import pet8 from "../../images/pets-images/pet8.jpg";
import pet9 from "../../images/pets-images/pet9.jpg";
import pet10 from "../../images/pets-images/pet10.jpg";
import pet11 from "../../images/pets-images/pet11.jpg";
import pet12 from "../../images/pets-images/pet12.jpg";
import pet13 from "../../images/pets-images/pet13.jpg";
import pet14 from "../../images/pets-images/pet14.jpg";
import pet15 from "../../images/pets-images/pet15.jpg";
import pet16 from "../../images/pets-images/pet16.jpg";
import pet17 from "../../images/pets-images/pet17.jpg";
import pet18 from "../../images/pets-images/pet18.jpg";
import pet19 from "../../images/pets-images/pet19.jpg";
import pet20 from "../../images/pets-images/pet20.jpg";
import pet21 from "../../images/pets-images/pet21.jpg";
import pet22 from "../../images/pets-images/pet22.jpg";
import pet23 from "../../images/pets-images/pet23.jpg";
import pet24 from "../../images/pets-images/pet24.jpg";
import pet25 from "../../images/pets-images/pet25.jpg";
import pet26 from "../../images/pets-images/pet26.jpg";
import pet27 from "../../images/pets-images/pet27.jpg";
import pet28 from "../../images/pets-images/pet28.jpg";
import pet29 from "../../images/pets-images/pet29.jpg";
import pet30 from "../../images/pets-images/pet30.jpg";
import pet31 from "../../images/pets-images/pet31.jpg";
import pet32 from "../../images/pets-images/pet32.jpg";

const itemData = [
    { img: pet1, title: "Питомец 1", cols: 1, rows: 1 },
    { img: pet2, title: "Питомец 2", cols: 1, rows: 1 },
    { img: pet3, title: "Питомец 3", cols: 1, rows: 1 },
    { img: pet4, title: "Питомец 4", cols: 1, rows: 1, featured: true },
    { img: pet5, title: "Питомец 5", cols: 1, rows: 1 },
    { img: pet6, title: "Питомец 6", cols: 1, rows: 1 },
    { img: pet7, title: "Питомец 7", cols: 1, rows: 2 },
    { img: pet8, title: "Питомец 8", cols: 1, rows: 1 },
    { img: pet9, title: "Питомец 9", cols: 2, rows: 1 },
    { img: pet10, title: "Питомец 10", cols: 1, rows: 1 },
    { img: pet11, title: "Питомец 11", cols: 1, rows: 1 },
    { img: pet12, title: "Питомец 12", cols: 1, rows: 1 },
    { img: pet13, title: "Питомец 13", cols: 1, rows: 1 },
    { img: pet14, title: "Питомец 14", cols: 1, rows: 1 },
    { img: pet15, title: "Питомец 15", cols: 2, rows: 2, featured: true },
    { img: pet16, title: "Питомец 16", cols: 1, rows: 1 },
    { img: pet17, title: "Питомец 17", cols: 1, rows: 1 },
    { img: pet18, title: "Питомец 18", cols: 1, rows: 1 },
    { img: pet19, title: "Питомец 19", cols: 1, rows: 1 },
    { img: pet20, title: "Питомец 20", cols: 1, rows: 2 },
    { img: pet21, title: "Питомец 21", cols: 1, rows: 1 },
    { img: pet22, title: "Питомец 22", cols: 2, rows: 1 },
    { img: pet23, title: "Питомец 23", cols: 1, rows: 1 },
    { img: pet24, title: "Питомец 24", cols: 1, rows: 1 },
    { img: pet25, title: "Питомец 25", cols: 1, rows: 1 },
    { img: pet26, title: "Питомец 26", cols: 1, rows: 1 },
    { img: pet27, title: "Питомец 27", cols: 2, rows: 2, featured: true },
    { img: pet28, title: "Питомец 28", cols: 1, rows: 1 },
    { img: pet29, title: "Питомец 29", cols: 1, rows: 1 },
    { img: pet30, title: "Питомец 30", cols: 1, rows: 1 },
    { img: pet31, title: "Питомец 31", cols: 1, rows: 1 },
    { img: pet32, title: "Питомец 32", cols: 1, rows: 1 },
];

export default function PetsPage(): JSX.Element {
    const theme = useTheme();
    const isXs = useMediaQuery(theme.breakpoints.only("xs"));
    const isSm = useMediaQuery(theme.breakpoints.only("sm"));
    const isMd = useMediaQuery(theme.breakpoints.only("md"));
    const cols = isXs ? 1 : isSm ? 2 : isMd ? 3 : 4;

    const [dialogOpen, setDialogOpen] = useState(false);
    const [selectedIndex, setSelectedIndex] = useState(0);
    const current = itemData[selectedIndex];

    const openDialog = (index: number) => {
        setSelectedIndex(index);
        setDialogOpen(true);
    };

    const closeDialog = () => setDialogOpen(false);

    const goPrev = () => {
        setSelectedIndex((i) => (i <= 0 ? itemData.length - 1 : i - 1));
    };

    const goNext = () => {
        setSelectedIndex((i) => (i >= itemData.length - 1 ? 0 : i + 1));
    };

    return (
        <Box
            sx={{
                width: "100%",
                minHeight: "100vh",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                bgcolor: "background.default",
                overflowX: "hidden",
                pt: { xs: 12, md: 10 },
            }}
        >
            {/* Заголовок страницы */}
            <Box
                sx={{
                    width: "100%",
                    py: { xs: 2.5, sm: 3 },
                    px: 2,
                    bgcolor: "background.default",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    textAlign: "center",
                }}
            >
                <FadeInWhenVisible variant="fade" timeout={400}>
                    <SectionTitle>Питомцы</SectionTitle>
                </FadeInWhenVisible>
            </Box>

            {/* Галерея */}
            <Box
                sx={{
                    width: "100%",
                    flex: 1,
                    bgcolor: "background.paper",
                    py: { xs: 2, md: 5 },
                    px: { xs: 1, sm: 3 },
                }}
            >
                <FadeInWhenVisible variant="grow" timeout={600} rootMargin="0px 0px -60px 0px">
                    <Box
                        sx={{
                            maxWidth: 1400,
                            mx: "auto",
                            width: "100%",
                        }}
                    >
                        <ImageList
                            variant="quilted"
                            cols={cols}
                            gap={8}
                            sx={(theme) => ({
                                height: "auto",
                                m: 0,
                                pb: 0,
                                "& .MuiImageListItem-root": {
                                    borderRadius: 2,
                                    overflow: "hidden",
                                    boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
                                    transition: "transform 0.3s ease, box-shadow 0.3s ease",
                                    cursor: "pointer",
                                    "&:hover": {
                                        transform: "scale(1.03)",
                                        boxShadow: `0 12px 32px ${theme.palette.secondary.main}30`,
                                    },
                                    "&:hover .pets-gallery-bar": { opacity: 1 },
                                    "&:hover .pets-gallery-zoom": { opacity: 1 },
                                    height: { xs: 140, sm: "auto" },
                                    maxHeight: { xs: 140, sm: "none" },
                                    minHeight: { xs: 100, sm: "auto" },
                                    "& img": {
                                        height: "100%",
                                        objectFit: "contain",
                                        transition: "transform 0.4s ease",
                                        "&:hover": { transform: "scale(1.05)" },
                                    },
                                    // Убираем лишние внутренние отступы на мобильных
                                    p: { xs: 0.5, sm: 1 },
                                    // Улучшаем отображение при маленьких размерах
                                    m: { xs: 0.5, sm: 1 },
                                },
                            })}
                        >
                            {itemData.map((item, index) => (
                                <ImageListItem
                                    key={index}
                                    cols={item.cols || 1}
                                    rows={item.rows || 1}
                                    onClick={() => openDialog(index)}
                                    sx={{ position: "relative" }}
                                >
                                    <img
                                        srcSet={`${item.img}?w=${164 * (item.cols || 1)}&fit=crop&auto=format&dpr=2 2x`}
                                        src={`${item.img}?w=${164 * (item.cols || 1)}&fit=crop&auto=format`}
                                        alt={item.title}
                                        loading="lazy"
                                        draggable={false}
                                        //style={{ height: "140px", objectFit: "contain" }}
                                    />
                                    <ImageListItemBar
                                        className="pets-gallery-bar"
                                        //title={item.title}
                                        sx={{
                                            background: "linear-gradient(to top, rgba(0,0,0,0.75) 0%, transparent 100%)",
                                            opacity: { xs: 1, md: 0 },
                                            transition: "opacity 0.3s ease",
                                            "& .MuiImageListItemBar-title": {
                                                fontWeight: 600,
                                                fontSize: "0.95rem",
                                            },
                                        }}
                                    />
                                </ImageListItem>
                            ))}
                        </ImageList>
                    </Box>
                </FadeInWhenVisible>
            </Box>

            {/* Диалог просмотра фото */}
            <Dialog
                open={dialogOpen}
                onClose={closeDialog}
                maxWidth={false}
                fullWidth
                PaperProps={{
                    sx: {
                        maxWidth: "95vw",
                        maxHeight: "95vh",
                        bgcolor: "rgba(0,0,0,0.92)",
                        boxShadow: "none",
                    },
                }}
                slotProps={{
                    backdrop: { sx: { bgcolor: "rgba(0,0,0,0.9)" } },
                }}
            >
                <DialogContent
                    sx={{
                        p: 0,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        position: "relative",
                        minHeight: { xs: 280, sm: 400 },
                    }}
                >
                    <IconButton
                        aria-label="закрыть"
                        onClick={closeDialog}
                        sx={{
                            position: "absolute",
                            right: 8,
                            top: 8,
                            zIndex: 2,
                            color: "common.white",
                            bgcolor: "rgba(255,255,255,0.1)",
                            "&:hover": { bgcolor: "rgba(255,255,255,0.2)" },
                        }}
                    >
                        <CloseIcon />
                    </IconButton>

                    <IconButton
                        aria-label="предыдущее фото"
                        onClick={goPrev}
                        sx={{
                            position: "absolute",
                            left: { xs: 4, sm: 8 },
                            top: "50%",
                            transform: "translateY(-50%)",
                            zIndex: 2,
                            color: "common.white",
                            bgcolor: "rgba(255,255,255,0.15)",
                            "&:hover": { bgcolor: "rgba(255,255,255,0.25)", color: "secondary.main" },
                        }}
                    >
                        <ArrowBackIcon />
                    </IconButton>

                    {current && (
                        <Box
                            component="img"
                            src={current.img}
                            alt={current.title}
                            sx={{
                                maxWidth: "100%",
                                maxHeight: "90vh",
                                objectFit: "contain",
                                borderRadius: 1,
                            }}
                        />
                    )}

                    <IconButton
                        aria-label="следующее фото"
                        onClick={goNext}
                        sx={{
                            position: "absolute",
                            right: { xs: 4, sm: 8 },
                            top: "50%",
                            transform: "translateY(-50%)",
                            zIndex: 2,
                            color: "common.white",
                            bgcolor: "rgba(255,255,255,0.15)",
                            "&:hover": { bgcolor: "rgba(255,255,255,0.25)", color: "secondary.main" },
                        }}
                    >
                        <ArrowForwardIcon />
                    </IconButton>
                </DialogContent>
            </Dialog>
        </Box>
    );
}
